"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import "./HomePageBannerNew.css";
import WebBeyondSpaces from "../WebBeyondSpaces/WebBeyondSpaces";
import MobBeyondSpaces from "../MobBeyondSpaces/MobBeyondSpaces";

export default function HomePageBannerNew({
  banners,
  bannersMobile,
  scrollToSection,
  section2Ref,
}) {
  const [showBeyond, setShowBeyond] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBeyond(true);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      className="relative"
      id="home-banner-nb-buildcon"
      style={{ overflow: "hidden" }}
    >
      <motion.div
        className="home-banner-nb-new relative"
        style={{ aspectRatio: "96/67" }}
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 1.2,
          ease: "easeOut",
        }}
      >
        {/* Desktop Banner */}
        <div className="hide-tab-mobile" style={{ height: "100%" }}>
          <Swiper
            modules={[Autoplay, EffectFade]}
            effect="fade"
            speed={1200}
            loop={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            className="home-banner-swiper"
          >
            {banners?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="banner-slide-image relative">
                  <motion.div
                    className="absolute-full"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 1.2,
                      ease: "easeOut",
                    }}
                  >
                    <Image
                      src={item.image}
                      fill
                      priority={index === 0}
                      alt={item.title || ""}
                    />
                  </motion.div>

                  <div className="banner-home-overlay"></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Mobile Banner */}
        <div className="visible-tab-mobile" style={{ height: "100%" }}>
          <Swiper
            modules={[Autoplay, EffectFade]}
            effect="fade"
            speed={1200}
            loop={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            className="home-banner-swiper"
          >
            {bannersMobile?.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="banner-slide-image relative">
                  <Image
                    src={item.image}
                    fill
                    priority={index === 0}
                    alt={item.title || ""}
                  />
                  <div className="banner-home-overlay"></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </motion.div>

      <div
        className="scroll-to-bottom"
        onClick={() => scrollToSection(section2Ref)}
      >
        <img src="/images/new-icons/scroll-bottom.svg" alt="" />
      </div>

      <AnimatePresence>
        {showBeyond && (
          <motion.div
            className="banner-title-new-home-wrapper"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="banner-title-wrapper main-container">
              {/* <div className="hide-tab-mobile">
                <WebBeyondSpaces />
              </div> */}

              {/* <div className="visible-tab-mobile"> */}
              <MobBeyondSpaces />
              {/* </div> */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
